import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from 'environments/environment';

import {
	GetMarketplaceCategoriesNavigationItemModel,
	GetMarketplaceFeaturedCategoriesCarouselItemModel,
	GetMarketplaceFeaturedListingsResponseModel,
	GetMarketplaceFeaturedTilesResponseModel,
} from '../models/categories.models';
import { KeyValuePair } from '../models/common.models';

@Injectable({
	providedIn: 'root',
})
export class CategoriesService {
	private get baseApiUrl(): string {
		return environment.marketplaceUrl;
	}

	constructor(private http: HttpClient) {}

	getNavigationItemsV1(): Observable<GetMarketplaceCategoriesNavigationItemModel[]> {
		const url = `${this.baseApiUrl}/v1/MarketplaceCategory`;
		return this.http.get<GetMarketplaceCategoriesNavigationItemModel[]>(url, {});
	}

	getCategoriesV1(): Observable<KeyValuePair<number, string>[]> {
		const url = `${this.baseApiUrl}/v1/MarketplaceCategory/lookup`;
		return this.http.get<KeyValuePair<number, string>[]>(url, {});
	}

	getFeaturedWineListingsV1(): Observable<GetMarketplaceFeaturedListingsResponseModel[]> {
		const url = `${this.baseApiUrl}/v1/MarketplaceCategory/featuredWines`;
		return this.http.get<GetMarketplaceFeaturedListingsResponseModel[]>(url, {});
	}

	getFeaturedWineTilesV1(): Observable<GetMarketplaceFeaturedTilesResponseModel[]> {
		const url = `${this.baseApiUrl}/v1/MarketplaceCategory/tiles`;
		return this.http.get<GetMarketplaceFeaturedTilesResponseModel[]>(url, {});
	}

	getFeaturedCarouselSlides(): Observable<GetMarketplaceFeaturedCategoriesCarouselItemModel[]> {
		const url = `${this.baseApiUrl}/v1/MarketplaceCategory/slides`;
		return this.http.get<GetMarketplaceFeaturedCategoriesCarouselItemModel[]>(url, {});
	}
}
